import React from "react";

import { Gallery } from "../components/Gallery";

export const EventsPage = () => {
  return <Gallery filter="events" />;
};
